import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

const tones = {
  neutral: 'bg-muted text-muted-foreground ring-border',
  good: 'bg-accent text-accent-foreground ring-primary/25',
  warn: 'bg-brass/15 text-amber-ink ring-brass/40',
  bad: 'bg-oxblood/10 text-oxblood-ink ring-oxblood/30',
};

export function Pill({ tone = 'neutral', children }: { tone?: keyof typeof tones; children: ReactNode }) {
  return <span className={cn('inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset', tones[tone])}>{children}</span>;
}
